/**
 * @generated SignedSource<<4e33e660161a5fc3b787cbbb6cdf4bc1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RenameOption_renameFolderNode_Mutation$variables = {
  folderNodeId: string;
  name: string;
};
export type RenameOption_renameFolderNode_Mutation$data = {
  readonly updateFolderNode: {
    readonly folderNodeUpdated: {
      readonly id?: string;
      readonly name?: string;
    };
  } | null;
};
export type RenameOption_renameFolderNode_Mutation = {
  response: RenameOption_renameFolderNode_Mutation$data;
  variables: RenameOption_renameFolderNode_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "folderNodeId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "folderNodeId",
        "variableName": "folderNodeId"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "FolderNodeInterface",
  "abstractKey": "__isFolderNodeInterface"
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RenameOption_renameFolderNode_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FilesAndFoldersUpdateFolderNodeMutationPayload",
        "kind": "LinkedField",
        "name": "updateFolderNode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "folderNodeUpdated",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RenameOption_renameFolderNode_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FilesAndFoldersUpdateFolderNodeMutationPayload",
        "kind": "LinkedField",
        "name": "updateFolderNode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "folderNodeUpdated",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e305f707e502bef77f2a531bbcdefa45",
    "id": null,
    "metadata": {},
    "name": "RenameOption_renameFolderNode_Mutation",
    "operationKind": "mutation",
    "text": "mutation RenameOption_renameFolderNode_Mutation(\n  $folderNodeId: ID!\n  $name: String!\n) {\n  updateFolderNode(input: {folderNodeId: $folderNodeId, name: $name}) {\n    folderNodeUpdated {\n      __typename\n      ... on FolderNodeInterface {\n        __isFolderNodeInterface: __typename\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3dde30e51603c8b20ba2b07f8ca78c88";

export default node;
